export default "__VITE_ASSET__b60ab100__"